// task ใน queue return ค่านี้เพื่อหยุด bootstrap (เช่น กำลัง redirect ไปเว็บอื่น) แทนการ throw ที่ Sentry จะจับเป็น error
export const BOOTSTRAP_STOP = Symbol("bootstrap-stop");

// auth ,  restore, fetch, watch , ready
export const useBootstrapStore = defineStore("bootstrap", {
  state: () => {
    return {
      ready: "splash", // splash, loading, ready    ,
      queue: [] as any[],
      loadHomePage: false,
      loadingList: [
        "Load User",
        "Restore Data",
        "Fetch Version",
        "Fetch Jobs",
        "Fetch Setting",
        "Fetch Employees",
        "Fetch Products",
        "Fetch Receipts",
        "Fetch QR CODE ORDERS",
        "Fetch POS",
        "READY",
      ],
      currentLoadingIndex: 0,
    };
  },

  actions: {
    init() {
      const jobsStore = useJobsStore();
      const authStore = useAuthStore();
      const posStore = usePosStore();
      const productStore = useProductsStore();
      const inventoryStore = useInventoryStore();
      const inventoryTransactionStore = useInventoryTransactionStore();
      const receiptStore = useReceiptsStore();
      const shopStore = useShopStore();
      const settingStore = useSettingsStore();
      const employeesStore = useEmployeesStore();
      const employeePinStore = useEmployeePinStore();
      const qrCodeStore = useQrCodeStore();
      const qrCodeOrders = useQrCodeOrdersStore();
      const onlineStatus = useOnlineStatusStore();
      const userStore = useUserStore();
      this.queue = [
        {
          name: "auth",
          fn: authStore.init,
          args: [],
          loadingIndex: 0,
        },
        {
          name: "shop",
          fn: shopStore.init,
          args: [],
        },
        {
          name: "beta",
          fn: shopStore.fetchBetaWhiteLists,
          args: [],
        },
        {
          name: "settings",
          fn: settingStore.main,
          args: [],
        },
        {
          name: "products",
          fn: productStore.main,
          args: [],
        },
        {
          name: "jobs",
          fn: jobsStore.init,
          args: [],
        },

        {
          name: "employees",
          fn: employeesStore.main,
          args: [],
        },

        {
          name: "receipts",
          // fn: receiptStore.init,
          fn: function () {
            setTimeout(() => {
              let openShop = jobsStore.getBusinessDate;
              if (openShop) {
                receiptStore.date = openShop?.businessDate;
              }
              receiptStore.init();
              useReceiptIdCounterStore().boot(receiptStore.date);
            }, 4000);
          },
          args: [],
        },
        {
          name: "inventories",
          fn: inventoryStore.init,
          args: [],
        },
        {
          name: "inventoriesTransaction",
          fn: inventoryTransactionStore.init,
          args: [],
        },

        {
          name: "qrcode",
          fn: qrCodeStore.init,
          args: [],
        },
        {
          name: "qrcodeOrders",
          fn: qrCodeOrders.init,
          args: [],
        },
        {
          name: "pos",
          fn: posStore.init,
          args: [],
        },
        {
          name: "onlineStatus",
          fn: onlineStatus.init,
          args: [],
        },
        {
          name: "employeePin",
          fn: employeePinStore.init,
          args: [],
        },
        {
          name: "user",
          fn: userStore.init,
          args: [],
        },
      ];

      useServerTime();

      /// setup app
      this.preventDuplicateTab();
    },
    addTask(task) {
      // add task to queue
      this.queue.push(task);
    },
    async run() {
      for (let index = 0; index < this.queue.length; index++) {
        const q = this.queue[index];
        this.currentLoadingIndex = index;
        const result = await q.fn();
        // task ขอให้หยุด ไม่รัน task ที่เหลือ และไม่ set ready
        if (result === BOOTSTRAP_STOP) return;
      }
      this.currentLoadingIndex = this.loadingList.length - 1;
      this.ready = "ready";
    },
    setupApp() {},
    preventDuplicateTab() {
      const channel = new BroadcastChannel("tab");

      channel.postMessage("x-table-another-tab");
      // note that listener is added after posting the message

      channel.addEventListener("message", (msg) => {
        if (msg.data === "x-table-another-tab") {
          // message received from 2nd tab
          // alert('Cannot open multiple instances');
          alert("ไม่สามารถเปิดซ้ำหลายแท็บได้");
          window.location.href = "https://www.google.com";
        }
      });
    },
  },
});
